// src/features/dinningSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { DinningData, getDinningData, createDinningData, editDinningData } from '../../api/dinningApi';

interface DinningState {
  dinningData: DinningData | null;
  loading: boolean;
  error: string | null;
}

const initialState: DinningState = {
  dinningData: null,
  loading: false,
  error: null,
};

export const fetchDinningData = createAsyncThunk<DinningData>('dinning/fetchDinningData', async () => {
  const response = await getDinningData();
  return response;
});

export const addDinningData = createAsyncThunk<DinningData, DinningData>('dinning/addDinningData', async (dinningData) => {
  const response = await createDinningData(dinningData);
  return response;
});

export const updateDinningData = createAsyncThunk<DinningData, DinningData>('dinning/updateDinningData', async (dinningData) => {
  const response = await editDinningData(dinningData);
  return response;
});

const dinningSlice = createSlice({
  name: 'dinning',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDinningData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDinningData.fulfilled, (state, action: PayloadAction<DinningData>) => {
        state.loading = false;
        state.dinningData = action.payload;
      })
      .addCase(fetchDinningData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'An error occurred';
      })
      .addCase(addDinningData.fulfilled, (state, action: PayloadAction<DinningData>) => {
        state.dinningData = action.payload;
      })
      .addCase(updateDinningData.fulfilled, (state, action: PayloadAction<DinningData>) => {
        state.dinningData = action.payload;
      });
  },
});

export default dinningSlice.reducer;
